import { cva } from '@/styled-system/css';

export const radioRecipe = cva({
  base: {
    'display': 'inline-block',
    'cursor': 'pointer',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.Radio.ring.default} var(--shadow-color)',
      _notDisabled: {
        _focusVisible:
          'inset 0 0 0 {borderWidths.Radio.ring.default} var(--shadow-color), {shadows.focus}',
      },
    },
    'borderRadius': 'Radio',
    'boxShadowColor': {
      base: 'Radio.border.default',
      _notDisabled: {
        _hover: 'Radio.border.hover',
        _active: 'Radio.border.pressed',
      },
    },
    'width': 'Radio.ring.width',
    'height': 'Radio.ring.height',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },

    '&:checked': {
      boxShadow: {
        base: 'inset 0 0 0 {borderWidths.Radio.ring.selected} var(--shadow-color)',
        _notDisabled: {
          _focusVisible:
            'inset 0 0 0 {borderWidths.Radio.ring.selected} var(--shadow-color), {shadows.focus}',
        },
      },
      boxShadowColor: {
        base: 'Radio.border.selected',
        _notDisabled: {
          _hover: 'Radio.border.selectedHover',
          _active: 'Radio.border.selectedPressed',
        },
      },
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
  },
});
